(function () {
  'use strict';

  var SECTION_CLASS = 'shopify-section--shoppable-video';

  function destroySwipers(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-shoppable-video-swiper]').forEach(function (el) {
      if (el.swiperInstance) { el.swiperInstance.destroy(true, true); el.swiperInstance = null; }
      el.querySelectorAll('[data-sv-loop-fill]').forEach(function (clone) { clone.remove(); });
      delete el.dataset.svInit;
    });
  }

  function prepThemeBlockSlides(el) {
    var wrapper = el.querySelector('.swiper-wrapper');
    if (!wrapper) return;
    Array.prototype.forEach.call(wrapper.children, function (child) {
      if (child.classList.contains('shopify-block')) child.classList.add('swiper-slide');
    });
  }

  function buildSwiper(el) {
    if (el.dataset.svInit || !window.Swiper) return;
    prepThemeBlockSlides(el);
    var colsDesktop = parseInt(el.dataset.colsDesktop, 10) || 4;
    var colsLaptop = parseInt(el.dataset.colsLaptop, 10) || 4;
    var colsTablet = parseInt(el.dataset.colsTablet, 10) || 3;
    var colsMobile = parseInt(el.dataset.colsMobile, 10) || 1;
    var gap = parseInt(el.dataset.gap, 10) || 0;
    var delay = parseFloat(el.dataset.autoplay) || 0;
    var navStyle = el.dataset.nav || 'none';
    var peek = parseFloat(el.dataset.peek) || 0;
    var centered = el.dataset.centered === 'true';

    var loop = el.dataset.loop === 'true';
    function spv(cols) { return cols + peek; }
    var wrapperEl = el.querySelector('.swiper-wrapper');
    var slideRole = wrapperEl && wrapperEl.getAttribute('role') === 'list' ? 'listitem' : 'group';
    var maxCols = Math.max(colsDesktop, colsLaptop, colsTablet, colsMobile);
    var loopPeek = loop && peek > 0;
    var minForLoop = Math.ceil(maxCols + peek) * (loopPeek || centered ? 2 : 1) + 1;

    if (loop && wrapperEl) {
      var originals = Array.prototype.slice.call(
        wrapperEl.querySelectorAll(':scope > .swiper-slide')
      );
      if (originals.length > 0) {
        var guard = 0;
        while (
          wrapperEl.querySelectorAll(':scope > .swiper-slide').length < minForLoop &&
          guard < 10
        ) {
          originals.forEach(function (slide) {
            var clone = slide.cloneNode(true);
            clone.setAttribute('data-sv-loop-fill', '');
            wrapperEl.appendChild(clone);
          });
          guard++;
        }
      }
    }

    var opts = {
      slidesPerView: spv(colsMobile),
      spaceBetween: gap,
      centeredSlides: centered || loopPeek,
      watchOverflow: true,
      watchSlidesProgress: true,
      observer: true,
      observeParents: true,
      loop: loop,
      a11y: { scrollOnFocus: false, slideRole: slideRole },
      breakpoints: {}
    };

    if (loop) {
      opts.loopAdditionalSlides = 2;
    }
    opts.breakpoints[0] = { slidesPerView: spv(colsMobile), spaceBetween: gap };
    opts.breakpoints[576] = { slidesPerView: spv(colsTablet), spaceBetween: gap };
    opts.breakpoints[992] = { slidesPerView: spv(colsLaptop), spaceBetween: gap };
    opts.breakpoints[1400] = { slidesPerView: spv(colsDesktop), spaceBetween: gap };

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) delay = 0;
    if (delay > 0) {
      opts.autoplay = { delay: delay * 1000, disableOnInteraction: false, pauseOnMouseEnter: true };
    }
    if (navStyle === 'navigation' || navStyle === 'both') {
      opts.navigation = {
        nextEl: el.querySelector('.swiper-button-next'),
        prevEl: el.querySelector('.swiper-button-prev')
      };
    }
    if (navStyle === 'pagination' || navStyle === 'both') {
      var pagEl = el.querySelector('.swiper-pagination');

      opts.pagination = {
        el: pagEl,
        clickable: true
      };

      if (pagEl && pagEl.dataset.paginationStyle === 'bold') {
        if (delay > 0) {
          pagEl.style.setProperty('--ring-duration', delay + 's');
        }

        opts.pagination.renderBullet = function (index, className) {
          return (
            '<span class="' + className + ' custom-bullet">' +
            '<svg class="progress-ring" viewBox="0 0 34 34" aria-hidden="true">' +
            '<circle class="progress-ring-bg" cx="17" cy="17" r="16"></circle>' +
            '<circle class="progress-ring-fill" cx="17" cy="17" r="16"></circle>' +
            '</svg>' +
            '<span class="bullet-dot"></span>' +
            '</span>'
          );
        };
      }
    }


    var applyFocus = function (swiper) {
      if (window.ThemeSlideFocus) {
        window.ThemeSlideFocus.apply(swiper, { focusableSlides: false });
      }
    };
    opts.on = {
      afterInit: applyFocus,
      resize: applyFocus,
      update: applyFocus,
      breakpoint: function (swiper) {
        updateProductSwipers(el);
        applyFocus(swiper);
      },
      loopFix: function () { updateProductSwipers(el); },
      slideChangeTransitionEnd: function (swiper) {
        applyFocus(swiper);
        if (window.ThemeSlideFocus) {
          window.ThemeSlideFocus.followActive(swiper, el);
        }
      }
    };

    el.swiperInstance = new window.Swiper(el, opts);
    el.dataset.svInit = '1';
    if (window.SectionCarousel && window.SectionCarousel.bindAutoplayFocusPause) {
      window.SectionCarousel.bindAutoplayFocusPause(el, el.swiperInstance);
    }
    var content = el.closest('[data-sv-content]');
    if (content) {
      initAutoplayInView(content);
      initCardsMuted(content);
      bindStateSync(content);
    }
  }

  function initSwipers(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-shoppable-video-swiper]').forEach(buildSwiper);
  }


  function buildProductSwiper(el) {
    if (el.dataset.svProdInit || !window.Swiper) return;
    var group = el.closest('.sv-card__product-group') || el;
    el.swiperInstance = new window.Swiper(el, {
      slidesPerView: 'auto',
      spaceBetween: 10,
      watchOverflow: true,
      allowTouchMove: false,
      navigation: {
        nextEl: group.querySelector('[data-sv-product-next]'),
        prevEl: group.querySelector('[data-sv-product-prev]')
      }
    });
    el.dataset.svProdInit = '1';
  }

  function updateProductSwipers(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-sv-product-swiper]').forEach(function (el) {
      if (el.swiperInstance) el.swiperInstance.update();
    });
  }

  function initProductSwipers(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-sv-product-swiper]').forEach(buildProductSwiper);
  }

  function destroyProductSwipers(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-sv-product-swiper]').forEach(function (el) {
      if (el.swiperInstance) { el.swiperInstance.destroy(true, true); el.swiperInstance = null; }
      delete el.dataset.svProdInit;
    });
  }

  function waitForSwiper(root, n) {
    n = n || 0;
    if (window.Swiper) { initSwipers(root); initProductSwipers(root); return; }
    if (n < 40) setTimeout(function () { waitForSwiper(root, n + 1); }, 100);
  }

  var REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function setCardMuted(card, muted) {
    if (!card) return;
    card.classList.toggle('is-muted', muted);
    var btn = card.querySelector('[data-sv-mute-toggle]');
    if (!btn) return;
    btn.setAttribute('aria-pressed', muted ? 'false' : 'true');
    var label = muted ? btn.dataset.labelUnmute : btn.dataset.labelMute;
    if (label) btn.setAttribute('aria-label', label);
  }

  /* Keep a single audio track: mute every other card without touching its play state. */
  function muteOthers(current) {
    document.querySelectorAll('.sv-card video').forEach(function (v) {
      if (v === current) return;
      v.muted = true;
      setCardMuted(v.closest('.sv-card'), true);
    });
  }

  
  var stateSyncBound = new WeakSet();
  function bindStateSync(root) {
    var scope = root || document;
    scope.querySelectorAll('.sv-card video').forEach(function (video) {
      if (stateSyncBound.has(video)) return;
      stateSyncBound.add(video);
      var sync = function () {
        var card = video.closest('.sv-card');
        if (!card) return;
        card.classList.toggle('is-playing', !video.paused);
        var btn = card.querySelector('[data-sv-play-toggle]');
        if (btn) btn.setAttribute('aria-pressed', video.paused ? 'false' : 'true');
      };
      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);
      sync();
    });
  }

  /* Start every card muted (also covers cloned/duplicated cards). */
  function initCardsMuted(root) {
    var scope = root || document;
    scope.querySelectorAll('.sv-card video').forEach(function (video) {
      var card = video.closest('.sv-card');
      video.muted = true;
      setCardMuted(card, true);
    });
  }

  function initVideoControls(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-sv-content]').forEach(function (content) {
      if (content.dataset.svControlsInit) return;
      content.dataset.svControlsInit = '1';

      content.addEventListener('click', function (e) {
        var playBtn = e.target.closest('[data-sv-play-toggle]');
        if (playBtn) {
          var pWrap = playBtn.closest('.sv-card__video-wrap');
          var pVideo = pWrap && pWrap.querySelector('video');
          if (!pVideo) return;
          var pCard = pWrap.closest('.sv-card');
          if (pVideo.paused) {
            pVideo.play();
            playBtn.setAttribute('aria-pressed', 'true');
            if (pCard) pCard.classList.add('is-playing');
          } else {
            pVideo.pause();
            playBtn.setAttribute('aria-pressed', 'false');
            if (pCard) pCard.classList.remove('is-playing');
          }
          return;
        }

        var muteBtn = e.target.closest('[data-sv-mute-toggle]');
        if (muteBtn) {
          var mWrap = muteBtn.closest('.sv-card__video-wrap');
          var mVideo = mWrap && mWrap.querySelector('video');
          if (!mVideo) return;
          var mCard = mWrap.closest('.sv-card');
          if (mVideo.muted) {
            muteOthers(mVideo);
            mVideo.muted = false;
            setCardMuted(mCard, false);
          } else {
            mVideo.muted = true;
            setCardMuted(mCard, true);
          }
        }
      });
    });

    initCardsMuted(scope);
    bindStateSync(scope);
  }

  /* ── Autoplay in view ───────────────────────── */
  function initAutoplayInView(root) {
    if (REDUCED_MOTION) return;
    var scope = root || document;
    scope.querySelectorAll('[data-sv-content]').forEach(function (content) {
      var target = content.querySelector('[data-autoplay-in-view]');
      if (!target || target.dataset.autoplayInView !== 'true') return;

      if (!content.svObserver) {
        content.svObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var video = entry.target;
            var card = video.closest('.sv-card');
            if (entry.isIntersecting) {
              video.muted = true;
              setCardMuted(card, true);
              var playPromise = video.play();
              if (playPromise && playPromise.catch) playPromise.catch(function () { });
              if (card) card.classList.add('is-playing');
            } else {
              video.pause();
              if (card) card.classList.remove('is-playing');
            }
          });
        }, { threshold: 0.5 });
      }

      content.dataset.svIoInit = '1';
      content.querySelectorAll('.sv-card video').forEach(function (v) {
        content.svObserver.observe(v);
      });
    });
  }

  function destroyObservers(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-sv-content]').forEach(function (content) {
      if (content.svObserver) {
        content.svObserver.disconnect();
        content.svObserver = null;
      }
      delete content.dataset.svIoInit;
    });
  }

  /* ── Popup ──────────────────────────────────── */
  function popupSection(popup) {
    return popup.closest('.' + SECTION_CLASS) || popup.closest('.shoppable-video');
  }

  var FOCUSABLE_SELECTOR =
    'a[href], button, input, textarea, select, details, [tabindex], [contenteditable="true"]';
 
  function getPopupFocusable(dialog) {
    return Array.prototype.filter.call(
      dialog.querySelectorAll(FOCUSABLE_SELECTOR),
      function (el) {
        if (el.disabled) return false;
        if ((el.getAttribute('tabindex') || '').charAt(0) === '-') return false;
        if (el.closest('[inert]')) return false;
        if (!el.getClientRects().length) return false;
        return true;
      }
    );
  }
 
  function trapPopupFocus(dialog, event) {
    var items = getPopupFocusable(dialog);
    if (!items.length) {
      event.preventDefault();
      return;
    }
    var first = items[0];
    var last = items[items.length - 1];
    var active = document.activeElement;

    
    if (items.indexOf(active) === -1) {
      event.preventDefault();
      var target = null;
      if (active && active !== dialog && dialog.contains(active)) {
        var flag = event.shiftKey
          ? Node.DOCUMENT_POSITION_PRECEDING
          : Node.DOCUMENT_POSITION_FOLLOWING;
        for (var k = 0; k < items.length; k++) {
          if (active.compareDocumentPosition(items[k]) & flag) {
            target = items[k];
            if (!event.shiftKey) break;
          }
        }
      }
      (target || (event.shiftKey ? last : first)).focus();
      return;
    }

    if (event.shiftKey) {
      if (active === first) {
        event.preventDefault();
        last.focus();
      }
      return;
    }
    if (active === last) {
      event.preventDefault();
      first.focus();
    }
  }

  
  function syncNavDisabled(swiper) {
    if (!swiper || !swiper.el) return;
    var group = swiper.el.closest('.sv-popup__product-group');
    if (!group) return;
    group
      .querySelectorAll('[data-sv-popup-product-prev], [data-sv-popup-product-next]')
      .forEach(function (btn) {
        var atEdge =
          btn.classList.contains('swiper-button-disabled') ||
          btn.classList.contains('swiper-button-lock');
        btn.disabled = false;
        btn.setAttribute('aria-disabled', atEdge ? 'true' : 'false');
      });
  }

  // Runs AFTER Swiper click handler - tab control 
  function restoreNavFocus() {
    var group = this.closest('.sv-popup__product-group');
    if (group && group._prodSwiper) syncNavDisabled(group._prodSwiper);
    this.focus();
  }

  function syncProductSlideInert(swiper) {
    if (!swiper || !swiper.slides) return;
    Array.prototype.forEach.call(swiper.slides, function (slide) {
      if (slide.classList.contains('swiper-slide-visible')) {
        slide.removeAttribute('inert');
      } else {
        slide.setAttribute('inert', '');
      }
    });
  }

 var pausedByPopup = [];

  function pauseGridVideos() {
    pausedByPopup = [];
    document.querySelectorAll('.sv-card video').forEach(function (v) {
     if (v.paused) return;
      pausedByPopup.push(v);
      v.pause();
      var card = v.closest('.sv-card');
      if (card) card.classList.remove('is-playing');
    });
  }

  function resumeGridVideos() {
    pausedByPopup.forEach(function (v) {
      if (!v.isConnected) return; 
      v.muted = true;
      setCardMuted(v.closest('.sv-card'), true);
      var p = v.play();
      if (p && p.catch) p.catch(function () { });
    });
    pausedByPopup = [];
  }


  function realCards(content) {
    var cards = Array.prototype.slice.call(content.querySelectorAll('[data-sv-card]'));
    var indexed = cards.every(function (c) {
      return c.getAttribute('data-swiper-slide-index') !== null;
    });
    if (!indexed) return cards;
    return cards.sort(function (a, b) {
      return a.getAttribute('data-swiper-slide-index') - b.getAttribute('data-swiper-slide-index');
    });
  }

  function harvestCards(content) {
    var cards = [];
    realCards(content).forEach(function (card) {
      cards.push({
        src: card.dataset.svVideoSrc || '',
        type: card.dataset.svVideoType || 'video/mp4',
        poster: card.dataset.svPoster || '',
        products: card.querySelectorAll('.sv-card__product-item')
      });
    });
    return cards;
  }

  function buildPopupContent(popup, cards) {
    if (popup.dataset.svBuilt) return;

    var track = popup.querySelector('[data-sv-popup-video-track]');
    var products = popup.querySelector('[data-sv-popup-products]');
    if (!track || !products) return;

    var placeholderVideo = 'https://cdn.shopify.com/videos/c/o/v/fbb140fd46e3429eba459e1549dbbe38.mp4';

    cards.forEach(function (card, i) {
      var slide = document.createElement('div');
      slide.className = 'swiper-slide sv-popup__video-slide';

      var video = document.createElement('video');

      video.className = 'sv-popup__video w-100 h-100 object-fit-cover';
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.preload = 'metadata';

      var source = document.createElement('source');

      source.src = card.src || placeholderVideo;
      source.type = card.src ? card.type : 'video/mp4';

      video.appendChild(source);
      slide.appendChild(video);

      track.appendChild(slide);

      var group = document.createElement('div');
      group.className = 'sv-popup__product-group';
      group.setAttribute('data-group-index', i);

      var pSwiper = document.createElement('div');
      pSwiper.className = 'swiper sv-popup__product-swiper';

      var pWrap = document.createElement('div');
      pWrap.className = 'swiper-wrapper';

      card.products.forEach(function (item) {
        var pSlide = document.createElement('div');
        pSlide.className = 'swiper-slide sv-popup__product-slide';

        pSlide.appendChild(item.cloneNode(true));
        pWrap.appendChild(pSlide);
      });

      pSwiper.appendChild(pWrap);
      group.appendChild(pSwiper);

      if (card.products.length > 1) {
        group.appendChild(
          buildProductNav('prev', popup.dataset.labelPrev)
        );

        group.appendChild(
          buildProductNav('next', popup.dataset.labelNext)
        );
      }

      products.appendChild(group);
    });

    popup.dataset.svBuilt = '1';
  }

  function buildProductNav(dir, label) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'sv-popup__product-nav sv-popup__product-nav--' + dir;
    btn.setAttribute(dir === 'prev' ? 'data-sv-popup-product-prev' : 'data-sv-popup-product-next', '');
    if (label) btn.setAttribute('aria-label', label);
    var d = dir === 'prev' ? 'm15 18-6-6 6-6' : 'm9 18 6-6-6-6';
    btn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + d + '"/></svg>';
    return btn;
  }

  function initPopupProductSwiper(group) {
    if (group.dataset.svProdInit || !window.Swiper) return;
    var el = group.querySelector('.sv-popup__product-swiper');
    if (!el) return;
    var nextBtn = group.querySelector('[data-sv-popup-product-next]');
    var prevBtn = group.querySelector('[data-sv-popup-product-prev]');
    function syncNavState() {
      syncProductSlideInert(this);
      syncNavDisabled(this);
    }
    group._prodSwiper = new window.Swiper(el, {
      slidesPerView: 'auto',
      spaceBetween: 10,
      watchOverflow: true,
      watchSlidesProgress: true,
      allowTouchMove: false,
      a11y: { scrollOnFocus: false },
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn
      },
      on: {
        init: syncNavState,
        slideChange: syncNavState,
        transitionEnd: syncNavState,
        update: syncNavState,
        toEdge: syncNavState,
        fromEdge: syncNavState
      }
    }); 
    [nextBtn, prevBtn].forEach(function (btn) {
      if (btn) btn.addEventListener('click', restoreNavFocus);
    });
    group.dataset.svProdInit = '1';
  }

  function popupActiveVideo(popup) {
    var swiper = popup._videoSwiper;
    if (!swiper || !swiper.slides) return null;
    var slide = swiper.slides[swiper.activeIndex];
    return slide ? slide.querySelector('video') : null;
  }

  function setPopupPlayState(popup, playing) {
    var btn = popup.querySelector('[data-sv-popup-play-toggle]');
    if (!btn) return;
    btn.classList.toggle('is-paused', !playing);
    btn.setAttribute('aria-pressed', playing ? 'true' : 'false');
    var label = playing ? btn.dataset.labelPause : btn.dataset.labelPlay;
    if (label) btn.setAttribute('aria-label', label);
  }

  function syncPopupActive(popup, swiper) {
    var i = swiper.activeIndex;
    var hold = popup.dataset.svUserPaused === '1';
    popup.querySelectorAll('.sv-popup__video-slide video').forEach(function (v, idx) {
      if (idx === i) {
        v.muted = true;
        if (hold) {
          v.pause();
        } else {
          var p = v.play();
          if (p && p.catch) p.catch(function () { });
        }
      } else {
        v.pause();
        v.currentTime = 0;
      }
    });
    setPopupPlayState(popup, !hold);
    popup.querySelectorAll('.sv-popup__product-group').forEach(function (g) {
      var active = parseInt(g.dataset.groupIndex, 10) === i;
      g.classList.toggle('is-active', active);
      if (active) {
        initPopupProductSwiper(g);
        if (g._prodSwiper) g._prodSwiper.update();
      }
    });
  }

  function initPopupSwiper(popup, index) {
    var el = popup.querySelector('[data-sv-popup-video-swiper]');
    if (!el || !window.Swiper) return null;
    var swiper = new window.Swiper(el, {
      slidesPerView: 1,
      initialSlide: index,
      watchOverflow: true,
      speed: REDUCED_MOTION ? 0 : 300,
      a11y: { scrollOnFocus: false },
      navigation: {
        nextEl: popup.querySelector('[data-sv-popup-next]'),
        prevEl: popup.querySelector('[data-sv-popup-prev]')
      },
      pagination: {
        el: popup.querySelector('[data-sv-popup-pagination]'),
        clickable: true
      },
      on: {
        slideChange: function () { syncPopupActive(popup, this); }
      }
    });
    popup._videoSwiper = swiper;
    return swiper;
  }

  function openPopup(popup, content, index) {
    var dialog = popup.querySelector('[data-sv-popup-dialog]');
    if (!dialog) return;

    if (!popup.dataset.svBuilt) buildPopupContent(popup, harvestCards(content));

    if (REDUCED_MOTION) popup.dataset.svUserPaused = '1';
    else delete popup.dataset.svUserPaused;

    pauseGridVideos();
    destroyObservers(popupSection(popup));

      if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }

    if (popup._videoSwiper) {
      popup._videoSwiper.slideTo(index, 0);
      popup._videoSwiper.update();
      syncPopupActive(popup, popup._videoSwiper);
    } else {
      var swiper = initPopupSwiper(popup, index);
      if (swiper) {
        swiper.update();
        syncPopupActive(popup, swiper);
      }
    }

    var closeBtn = popup.querySelector('[data-sv-popup-close]');
    if (closeBtn) closeBtn.focus();
  }
 
  function closePopup(popup) {
    var dialog = popup.querySelector('[data-sv-popup-dialog]');
    if (!dialog) return;
    if (typeof dialog.close === 'function') dialog.close();
    else {
      dialog.removeAttribute('open');
      restoreAfterPopup(popup);
    }
  }

  function restoreAfterPopup(popup) {
    popup.querySelectorAll('.sv-popup__video-slide video').forEach(function (v) {
      v.pause();
      v.currentTime = 0;
    });
    resumeGridVideos();
    if (popup._opener && popup._opener.focus) popup._opener.focus();
  }

  function initPopup(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-sv-content]').forEach(function (content) {
      if (content.dataset.svPopupEnabled !== 'true') return;
      var section = content.closest('.' + SECTION_CLASS) || content.closest('.shoppable-video');
      if (!section) return;
      var popup = section.querySelector('[data-sv-popup]');
      if (!popup || popup.dataset.svPopupInit) return;
      popup.dataset.svPopupInit = '1';

     
      content.addEventListener('click', function (e) {
        var opener = e.target.closest('[data-sv-popup-open]');
        if (!opener) return;
        var card = opener.closest('[data-sv-card]');
        if (!card) return;
        var index = realCards(content).indexOf(card);
        if (index < 0) index = 0;
        popup._opener = opener;
        openPopup(popup, content, index);
      });

      var dialog = popup.querySelector('[data-sv-popup-dialog]');
      var closeBtn = popup.querySelector('[data-sv-popup-close]');
      if (closeBtn) closeBtn.addEventListener('click', function () { closePopup(popup); });
      var playToggle = popup.querySelector('[data-sv-popup-play-toggle]');
      if (playToggle) {
        playToggle.addEventListener('click', function () {
          var video = popupActiveVideo(popup);
          if (!video) return;
          if (video.paused) {
            delete popup.dataset.svUserPaused;
            var p = video.play();
            if (p && p.catch) p.catch(function () { });
            setPopupPlayState(popup, true);
          } else {
            popup.dataset.svUserPaused = '1';
            video.pause();
            setPopupPlayState(popup, false);
          }
        });
      }
      if (dialog) {
        dialog.addEventListener('click', function (e) {
          if (e.target === dialog) closePopup(popup);
        }); 
        dialog.addEventListener('close', function () {
          restoreAfterPopup(popup);
        });

        popup._onKeydown = function (e) {
          if (!dialog.hasAttribute('open')) return;
          if (e.key === 'Tab') {
            trapPopupFocus(dialog, e);
            return;
          } 
          if (e.key === 'Escape' && typeof dialog.showModal !== 'function') {
            e.preventDefault();
            closePopup(popup);
          }
        }; 
        document.addEventListener('keydown', popup._onKeydown);
      }
    });
  }

  function destroyPopups(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-sv-popup]').forEach(function (popup) {
      if (popup._videoSwiper) {
        popup._videoSwiper.destroy(true, true);
        popup._videoSwiper = null;
      }
      popup.querySelectorAll('.sv-popup__product-group').forEach(function (g) {
        if (g._prodSwiper) { g._prodSwiper.destroy(true, true); g._prodSwiper = null; }
      });
      if (popup._onKeydown) {
        document.removeEventListener('keydown', popup._onKeydown);
        popup._onKeydown = null;
      }
      var track = popup.querySelector('[data-sv-popup-video-track]');
      var products = popup.querySelector('[data-sv-popup-products]');
      if (track) track.innerHTML = '';
      if (products) products.innerHTML = '';
      delete popup.dataset.svBuilt;
      delete popup.dataset.svPopupInit;
    });
  }

  if (!customElements.get('shoppable-video-popup')) {
    customElements.define('shoppable-video-popup', class extends HTMLElement { });
  }

  /* ── Init ───────────────────────────────────── */
  function init(root) {
    waitForSwiper(root);
    initVideoControls(root);
    initAutoplayInView(root);
    initPopup(root);
  }

  function isSection(node) {
    return node && node.classList && node.classList.contains(SECTION_CLASS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  window.addEventListener('load', function () { init(); });

  document.addEventListener('shopify:section:load', function (e) { if (!isSection(e.target)) return; destroySwipers(e.target); destroyProductSwipers(e.target); destroyObservers(e.target); destroyPopups(e.target); init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { if (!isSection(e.target)) return; destroySwipers(e.target); destroyProductSwipers(e.target); destroyObservers(e.target); destroyPopups(e.target); });
  document.addEventListener('shopify:section:select', function (e) { if (!isSection(e.target)) return; waitForSwiper(e.target); });
  document.addEventListener('shopify:block:select', function (e) { var s = e.target.closest('.' + SECTION_CLASS); if (s) waitForSwiper(s); });
  document.addEventListener('shopify:block:deselect', function (e) { var s = e.target.closest('.' + SECTION_CLASS); if (s) waitForSwiper(s); });
})();



function updateParentWidth(root) {
  var scope = root || document;

  scope.querySelectorAll('.video_container').forEach(function (element) {
    var parent = element.parentElement;

    if (parent) {
      parent.style.setProperty('--video-width', `${element.offsetWidth}px`);
    }
  });
}

updateParentWidth();